import React, { createContext, useContext, useReducer } from "react";
import BigNumber from "bignumber.js";

const StakingContext = createContext(null);

export const useStakings = () => useContext(StakingContext);

const INIT_STATE = {
  // Wallet varible
  balance: "0.000",
  accounts: [],
  startTime: undefined,
  endTime: undefined,
  currentRate: 0,
  totalSupply: BigNumber(0),
  allocated: BigNumber(0),
  purchased: BigNumber(0),
  isClaimed: false, // admin claimable setting
  isClaimable: false, // admin claimable setting
};

const reducer = (state: any, { type, payload }: any) => {
  return {
    ...state,
    [type]: payload,
  };
};

export default function Provider({ children }: any) {
  const [state, dispatch] = useReducer(reducer, INIT_STATE);
  const changeVariable = (key: any, value: any) => {
    dispatch({
      type: key,
      payload: value,
    });
  };
  return (
    <StakingContext.Provider value={{ state, changeVariable }}>
      {children}
    </StakingContext.Provider>
  );
}
